import React, { useEffect, useState } from 'react'
import getMovieListDataService from '../../../Services/Queries/GetMovieListServiceData'
// import BulkActionsMoviesList from '../BulkActionsMoviesList'
import { Auth } from 'aws-amplify'
import { toast } from 'react-toastify'
// import TableChildMovieList from './TableChildMovieList'
import { ToastStyle } from '../../Data/MovieStaticData'
import SearchMovieListsData from '../../../Services/Queries/LIstMoviesSearch'
// import DeleteMovieList from '../../../Services/Mutations/DeleteMovieList'
// import FliterOptions from './FliterOptions'
import './movielist.css'
// import SearchFilter from './SearchFilter'
import SearchFilterActionsTable from './SearchFilterActionsTable'
import UpdateMovieListStatusService from '../../../Services/Mutations/UpdateMovieListStatusService'
const TableMovieList = () => {
  const [DropDownsDisable, setDropDownsDisable] = useState(false)
  const [searchDisableOnDropDownSelect, SetsearchDisableOnDropDownSelect] = useState(true)
  const [disableInputOnDropDownSelect, setDisableInputOnDropDownSelect] = useState()
  const [onSearchingFilterDropDownsDisable, setOnSearchingFilterDropDownsDisable] = useState(false)
  const [loadMoreByServiceName, setLoadMoreByServiceName] = useState()
  const [fromValue, setFromValue] = useState(10)
  const [totalRenderedCount, setTotalRenderedCount] = useState(10)
  const [loadMore, setLoadMore] = useState(false)
  const [searchedValue, setSearchedValue] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [serviceData, setServiceData] = useState([])
  const [nextToken, setNextToken] = useState()
  const [checkBoxArr, setCheckBoxArr] = useState([])
  const [checkSelectedArrayLength, setcheckSelectedArrayLength] = useState()
  const [filterValueName, SetFilterValue] = useState('all')
  const [status, setStatus] = useState('published')
  const [movieAndPersonValue, setMovieAndPersonValue] = useState()
  const [UserAndEditValue, setUserAndEditValue] = useState()
  const [filterNextToken, setFilterNextToken] = useState()
  const [filterDisable, setFilterDisable] = useState(true)
  const listServiceCall = async filterValue => {
    setIsLoading(true)
    setLoadMoreByServiceName('getMovieListDataService')
    SetFilterValue(filterValue)
    let input
    if (filterValue === 'movieListTypeAndCategory') {
      input = {
        status,
        filterBy: filterValue,
        movieListCategory: movieAndPersonValue,
        movieListType: UserAndEditValue,
        limit: 10,
        nextToken: filterNextToken,
      }
    } else if (filterValue === 'movieListCategory') {
      input = {
        status,
        filterBy: filterValue,
        movieListCategory: movieAndPersonValue,
        limit: 10,
        nextToken: filterNextToken,
      }
    } else if (filterValue === 'movieListType') {
      input = {
        status,
        filterBy: filterValue,
        movieListType: UserAndEditValue,
        limit: 10,
        nextToken: filterNextToken,
      }
    } else if (filterValue === 'all') {
      input = { status, filterBy: filterValue, limit: 10, nextToken }
    }

    const listData = await getMovieListDataService(input)
    if (
      filterValue === 'movieListType' ||
      filterValue === 'movieListCategory' ||
      filterValue === 'movieListTypeAndCategory'
    ) {
      setFilterNextToken(listData.getMovieLists.nextToken)
    }

    const arrayList = [...serviceData, ...listData.getMovieLists.items]
    setServiceData(arrayList)
    setNextToken(listData.getMovieLists.nextToken)
    setLoadMore(listData.getMovieLists.nextToken !== null)
    setIsLoading(false)
  }

  const loadMoreData = async () => {
    if (loadMoreByServiceName === 'searchService') {
      filterBYSearchLoadMore()
    }

    if (loadMoreByServiceName === 'getMovieListDataService') {
      if (nextToken === null) {
        setLoadMore(false)
      } else {
        listServiceCall(filterValueName)
      }
    }
  }

  const filterBYSearch = async () => {
    setIsLoading(true)
    setFromValue(10)
    setTotalRenderedCount(10)
    setLoadMoreByServiceName('searchService')
    const input = {
      search: searchedValue,
      from: 0,
      limit: 10,
    }
    const searchedData = await SearchMovieListsData(input)
    setServiceData(searchedData.movieListHits)
    setTotalRenderedCount(10 + 10)

    if (searchedData.totalMovieListCount > 10) {
      setLoadMore(true)
    } else {
      setLoadMore(false)
    }

    setIsLoading(false)
  }

  const filterBYSearchLoadMore = async () => {
    setLoadMoreByServiceName('searchService')
    const input = {
      search: searchedValue,
      from: fromValue,
      limit: 10,
    }
    const searchedData = await SearchMovieListsData(input)
    setServiceData([...serviceData, ...searchedData.movieListHits])
    setFromValue(fromValue + 10)
    setTotalRenderedCount(totalRenderedCount + 10)
    if (totalRenderedCount < searchedData.totalMovieListCount) {
      setLoadMore(true)
    } else {
      setLoadMore(false)
    }
  }

  function checkboxfunction(e) {
    const checkSelectedArray = checkBoxArr
    if (checkSelectedArray.some(item => item.SK === e.target.value)) {
      const itemIndex = checkSelectedArray.findIndex(item => item.SK === e.target.value)
      if (itemIndex > -1) {
        checkSelectedArray.splice(itemIndex, 1)
      }
    } else {
      const objPKSK = { PK: e.target.name, SK: e.target.value }
      checkSelectedArray.push(objPKSK)
    }

    const filteredCheckDeleted = checkSelectedArray.filter(
      x => x.PK !== serviceData && serviceData.map(item => item.pk),
    )
    setCheckBoxArr(filteredCheckDeleted)
    setcheckSelectedArrayLength(checkSelectedArray.length)
  }

  let loggedInUserHandle = ''
  const loggedInUserEmail = Auth.user.attributes ? Auth.user.attributes.email : ''
  if (loggedInUserEmail) {
    const emailParams = loggedInUserEmail.split('@')
    loggedInUserHandle = '@' + emailParams[0]
  }

  const handleDeleteClick = async (e, _index) => {
    setIsLoading(true)
    // const deleteArray = []
    // const delObjValues = { SK, index }
    // deleteArray.push(delObjValues)
    // deleteArray.map(async item => {
    // const DeleteMovieListInput = { SK: item.SK, index: item.index }
    const DeleteMovie = await UpdateMovieListStatusService({
      movieListID: e.movieListID,
      status: 'deleted',
    })
    // const DeleteMovie = await DeleteMovieList(DeleteMovieListInput)
    // const statusCodevalue = DeleteMovie.data.deleteMovieList.statusCode
    if (DeleteMovie.statusCode === 'M022') {
      toast.success(DeleteMovie.statusMessage, ToastStyle)
      const remainingElements = serviceData && serviceData.filter(elem => elem.SK !== e.SK)
      setServiceData(remainingElements)
    }

    // return DeleteMovieListInput
    // })
    setIsLoading(false)
  }

  const dropDownMovieAndPerson = e => {
    setDisableInputOnDropDownSelect(true)

    SetsearchDisableOnDropDownSelect(true)
    // console.log(e.target.value, 'e.target.value')
    setMovieAndPersonValue(e.target.value)
    setFilterDisable(false)
  }

  const dropDownUserAndEdit = e => {
    setDisableInputOnDropDownSelect(true)
    SetsearchDisableOnDropDownSelect(true)
    // console.log(e.target.value, 'e.target.valueedit')
    setUserAndEditValue(e.target.value)
    setFilterDisable(false)
  }

  const resetButton = () => {
    setOnSearchingFilterDropDownsDisable(false)
    setDisableInputOnDropDownSelect(false)
    // SetsearchDisableOnDropDownSelect(true)
    setFromValue(10)
    // getListMoviesData('all')
    setStatus('published')
    setUserAndEditValue('')
    setMovieAndPersonValue('')
    setFilterDisable(true)
    getListMoviesData('all')
  }

  const filterButton = () => {
    setFromValue(10)
    // console.log('filter inside')

    if (
      (UserAndEditValue === 'User' || UserAndEditValue === 'Editorial') &&
      (movieAndPersonValue === 'Movie' ||
        movieAndPersonValue === 'Person' ||
        movieAndPersonValue === 'Text')
    ) {
      getListMoviesData('movieListTypeAndCategory')
    } else if (UserAndEditValue === 'User' || UserAndEditValue === 'Editorial') {
      getListMoviesData('movieListType')
    } else if (
      movieAndPersonValue === 'Movie' ||
      movieAndPersonValue === 'Person' ||
      movieAndPersonValue === 'Text'
    ) {
      getListMoviesData('movieListCategory')
    }
  }

  const getListMoviesData = async filterValue => {
    setLoadMoreByServiceName('getMovieListDataService')
    setIsLoading(true)
    SetFilterValue(filterValue)
    let input
    if (filterValue === 'movieListTypeAndCategory') {
      input = {
        status,
        filterBy: filterValue,
        movieListCategory: movieAndPersonValue,
        movieListType: UserAndEditValue,
        limit: 10,
      }
    } else if (filterValue === 'movieListCategory') {
      input = {
        status,
        filterBy: filterValue,
        movieListCategory: movieAndPersonValue,
        limit: 10,
      }
    } else if (filterValue === 'movieListType') {
      input = {
        status,
        filterBy: filterValue,
        movieListType: UserAndEditValue,
        limit: 10,
      }
    } else if (filterValue === 'all') {
      input = {
        status,
        filterBy: filterValue,
        limit: 10,
      }
    }

    const listData = await getMovieListDataService(input)
    if (
      filterValue === 'movieListType' ||
      filterValue === 'movieListCategory' ||
      filterValue === 'movieListTypeAndCategory'
    ) {
      setFilterNextToken(listData.getMovieLists.nextToken)
    }

    setServiceData(listData.getMovieLists.items)
    setNextToken(listData.getMovieLists.nextToken)
    setLoadMore(listData.getMovieLists.nextToken !== null)
    setIsLoading(false)
  }

  useEffect(() => {
    setNextToken('')
    setUserAndEditValue('')
    setMovieAndPersonValue('')
    setFilterDisable(true)
    getListMoviesData('all')
  }, [status])

  return (
    <div>
      <SearchFilterActionsTable
        setDropDownsDisable={setDropDownsDisable}
        SetsearchDisableOnDropDownSelect={SetsearchDisableOnDropDownSelect}
        disableInputOnDropDownSelect={disableInputOnDropDownSelect}
        setOnSearchingFilterDropDownsDisable={setOnSearchingFilterDropDownsDisable}
        setTotalRenderedCount={setTotalRenderedCount}
        setFromValue={setFromValue}
        searchedValue={searchedValue}
        setSearchedValue={setSearchedValue}
        filterBYSearch={filterBYSearch}
        setLoadMore={setLoadMore}
        getListMoviesData={getListMoviesData}
        setServiceData={setServiceData}
        searchDisableOnDropDownSelect={searchDisableOnDropDownSelect}
        onSearchingFilterDropDownsDisable={onSearchingFilterDropDownsDisable}
        DropDownsDisable={DropDownsDisable}
        filterDisable={filterDisable}
        resetButton={resetButton}
        filterButton={filterButton}
        movieAndPersonValue={movieAndPersonValue}
        UserAndEditValue={UserAndEditValue}
        dropDownMovieAndPerson={dropDownMovieAndPerson}
        dropDownUserAndEdit={dropDownUserAndEdit}
        status={status}
        setStatus={setStatus}
        handleDeleteClick={handleDeleteClick}
        loggedInUserHandle={loggedInUserHandle}
        checkSelectedArrayLength={checkSelectedArrayLength}
        setCheckBoxArr={setCheckBoxArr}
        serviceData={serviceData}
        checkBoxArr={checkBoxArr}
        isLoading={isLoading}
        loadMoreData={loadMoreData}
        loadMore={loadMore}
        checkboxfunction={checkboxfunction}
        SetFilterValue={SetFilterValue}
      />
    </div>
  )
}

export default TableMovieList
